import { render, staticRenderFns } from "./BlocoInformacao.vue?vue&type=template&id=44beb3f6&lang=pug"
import script from "./BlocoInformacao.vue?vue&type=script&lang=js"
export * from "./BlocoInformacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoInformacao.vue?vue&type=style&index=0&id=44beb3f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports